<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-16 16:19:25
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ImageNumber.vue
-->
<template>
    <div class="mt-4">
        <label class="flex items-center text-white text-sm font-semibold mb-3">
            {{
                props.create_type === 'VIDEO'
                    ? t('tools.videoNumber')
                    : t('tools.imageNumber')
            }}
            <ClientOnly v-if="props?.show_tips">
                <el-popover
                    width="180"
                    :content="t('seo.imageToImage.page.output')"
                >
                    <template #reference>
                        <img
                            class="w-3 h-3 ml-2 cursor-help"
                            src="https://static.weryai.com/growth/image/4c8570087b6d87697059b93e7295b008.webp"
                            alt="info"
                        />
                    </template>
                </el-popover>
            </ClientOnly>
        </label>
        
        <!-- 移动端：下拉列表 -->
        <div class="sm:hidden">
            <el-select
                v-model="output_image_number"
                class="w-full h-14 bg-[#1C1C20] border-white/[.06] rounded-lg border  hover:border-white/30"
                popper-class="image-number-popper"
                :fit-input-width="true"
            >
                <template #label>
                    <div class="flex items-center w-full">
                        <span class="text-white text-sm font-medium">{{ output_image_number }}</span>
                    </div>
                </template>
                <el-option
                    v-for="number in currentNumberList"
                    :key="number"
                    :label="number"
                    :value="number"
                >
                    <div class="flex items-center gap-2 h-full">
                        <img
                            :src="number === output_image_number ? checkedIcon : notCheckedIcon"
                            alt="checked"
                            class="w-5 h-5 object-cover"
                        />
                        <span class="text-white text-sm font-medium">{{ number }}</span>
                    </div>
                </el-option>
            </el-select>
        </div>

        <!-- PC端：按钮组 -->
        <div
            v-if="!props.batch_generate"
            class="hidden sm:flex w-full gap-2 items-center justify-start overflow-x-auto"
        >
            <button
                v-for="number in props.num_images"
                :key="number"
                @click="output_image_number = number"
                :class="[
                    'flex flex-1 max-w-[76px] h-[50px] text-white items-center border border-transparent justify-center rounded-[10px] transition-all duration-200  text-sm   cursor-pointer  ',
                    output_image_number !== number
                        ? 'bg-[#1C1C20] border-white/[.06] hover:border-white/30 !text-sub-title'
                        : '!border-white/50 !bg-white/10',
                ]"
            >
                {{ number }}
            </button>
        </div>
        <div
            v-else
            class="hidden sm:flex w-full gap-2 items-center justify-start overflow-x-auto"
        >
            <button
                v-for="number in batchNumberList"
                :key="number"
                @click="output_image_number = number"
                :class="[
                    'flex flex-1 max-w-[76px] h-[50px] items-center border border-transparent justify-center rounded-[10px] transition-all duration-200  text-sm   cursor-pointer  ',
                    output_image_number !== number
                        ? 'bg-[#1C1C20] border-white/[.06] hover:border-white/30 text-sub-title'
                        : '!border-white/50 !bg-white/10',
                ]"
            >
                {{ number }}
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'
const { t, locale } = useI18n()

const checkedIcon = 'https://static.weryai.com/growth/image/4ebae3f3edb8f4f52281d018c7816648.webp'
const notCheckedIcon = 'https://static.weryai.com/growth/image/bd6f71cdf35a64773b80d7a5a9930322.webp'

const props = defineProps({
    num_images: {
        type: Array<any>,
        default: () => [1, 2, 3, 4],
    },
    batch_generate: {
        type: Boolean,
        default: false,
    },
    create_type: {
        type: String,
        default: 'IMAGE',
    },
    show_tips: {
        type: Boolean,
        default: false,
    },
})

const batchNumberList = computed(() => {
    return [1, 2, 4, 8]
})

const currentNumberList = computed(() => {
    return props.batch_generate ? batchNumberList.value : props.num_images
})

const output_image_number = defineModel('output_image_number', {
    type: Number,
    default: 1,
})
</script>
<style lang="less">
// .select-popper {
//     background-color: #1C1C20 !important;
//     border: none !important;
//     box-shadow: none !important;
//     .el-select-dropdown__item {
//         height: 60px !important;
//         margin-bottom: 10px !important;
//         margin: 0 10px !important;
//         border-radius: 10px !important;
//         &.is-hovering {
//             color:#99F768 !important;
//             background-color: var(--select-hover-bg) !important;
//         }
//         &.is-selected {
//             background-color: transparent !important;
//         }
//     }
// }

.image-number-popper {
    background-color: #1C1C20 !important;
    border: none !important;
    box-shadow: none !important;
    .el-select-dropdown__item {
        height: 60px !important;
        margin-bottom: 10px !important;
        margin: 0 10px !important;
        border-radius: 10px !important;
        &.is-hovering {
            background-color: transparent !important;
        }
        &.is-selected {
            background-color: transparent !important;
        }
    }
}
</style>

<style scoped lang="less">
:deep(.el-select__wrapper) {
    height: 100%;
    background-color: transparent;
    border: none;
    box-shadow: none;
    &:hover {
        border: none;
        box-shadow: none;
    }
    &:focus-visible {
        border: none;
    }
}
</style>
